import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=7320c505&scoped=true"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=7320c505&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320c505",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7320c505')) {
      api.createRecord('7320c505', component.options)
    } else {
      api.reload('7320c505', component.options)
    }
    module.hot.accept("./dialogue.vue?vue&type=template&id=7320c505&scoped=true", function () {
      api.rerender('7320c505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/chat/widgets/dialogue.vue"
export default component.exports